import { Modal } from "antd";
import styled from "styled-components";

export const CsvImportModalStyle = styled(Modal)`
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  
  .ant-modal-mask {
    backdrop-filter: blur(5px) !important;
  }
  
  .ant-modal-content {
    backdrop-filter: blur(5px);
    color: ${(props) => props.theme.colors.primary};
    background: ${(props) => props.theme.background.secondary1};
    border: 1px solid #FFFFFF4D;
    max-width: 600px;
    border-radius: 20px;
    width: 100%;
  }

  .ant-modal-body {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .heading {
    color: ${(props) => props.theme.colors.primary};
    font-family: Poppins;
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0em;
    text-align: left;
    margin-bottom: 8px;
  }

  .description {
    color: ${(props) => props.theme.colors.primary};
    font-family: Public Sans;
    font-size: 12px;
    font-weight: 300;
    letter-spacing: 0em;
    text-align: left;
    opacity: 0.5;
    margin: 0;
  }

  .csvImportHead {
    border-bottom: 1px solid #ffffff4d;
    padding-bottom: 16px;
  }

  .csvImportForm {
    padding-top: 16px;
  }

  .upload-area {
    border: 2px dashed #FFFFFF33;
    border-radius: 8px;
    padding: 40px 20px;
    text-align: center;
    background: transparent;
    transition: all 0.3s ease;
    cursor: pointer;
    
    &:hover {
      border-color: #007AFF;
      background: rgba(0, 122, 255, 0.05);
    }
    
    &.dragover {
      border-color: #007AFF;
      background: rgba(0, 122, 255, 0.1);
    }
  }

  .upload-icon {
    font-size: 48px;
    color: #FFFFFF33;
    margin-bottom: 16px;
  }

  .upload-text {
    color: ${(props) => props.theme.colors.primary};
    font-size: 14px;
    margin-bottom: 8px;
  }

  .upload-subtext {
    color: ${(props) => props.theme.colors.primary};
    font-size: 12px;
    opacity: 0.7;
  }

  .file-input {
    display: none;
  }

  .example-section {
    margin-top: 20px;
    padding: 16px;
    background: #111823;
    border: 1px solid #FFFFFF33;
    border-radius: 8px;
  }

  .example-title {
    color: ${(props) => props.theme.colors.primary};
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .download-sample {
    background: none;
    border: 1px solid #007AFF;
    color: #007AFF;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 10px;
    cursor: pointer;
    
    &:hover {
      background: rgba(0, 122, 255, 0.1);
    }
  }

  .example-csv {
    background: #242A34;
    border: 1px solid #FFFFFF1A;
    border-radius: 4px;
    padding: 12px;
    font-family: 'Courier New', monospace;
    font-size: 11px;
    color: #e6e6e6;
    white-space: pre;
    overflow-x: auto;
  }

  .file-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background: #303036;
    border: 1px solid #FFFFFF33;
    border-radius: 8px;
    margin-top: 12px;
  }

  .file-details {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .file-icon {
    color: #007AFF;
    font-size: 16px;
  }

  .file-name {
    color: ${(props) => props.theme.colors.primary};
    font-size: 12px;
    font-weight: 500;
  }

  .file-size {
    color: ${(props) => props.theme.colors.primary};
    font-size: 11px;
    opacity: 0.7;
  }

  .remove-file {
    background: none;
    border: none;
    color: #EA4335;
    cursor: pointer;
    font-size: 14px;
    padding: 4px;
  }

  .error-message {
    color: #EA4335;
    font-size: 12px;
    margin-top: 8px;
  }

  .buttonDiv {
    width: 100%;
    justify-content: flex-end !important;
    display: flex;
    padding-top: 24px;
    gap: 12px;
  }

  .cancelButton {
    width: 100px;
    height: 38px;
    background: transparent;
    border: 1px solid #FFFFFF33;
    border-radius: 8px;
    color: ${(props) => props.theme.colors.primary};
    cursor: pointer;
    font-size: 12px;
    
    &:hover {
      background: rgba(255, 255, 255, 0.05);
    }
  }

  .importButton {
    width: 120px;
    height: 38px;
    padding: 12px, 32px, 12px, 32px;
    border-radius: 8px;
    background: #007AFF;
    border: none;
    cursor: pointer;
    font-size: 12px;
    color: white;
    
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
    
    &:hover:not(:disabled) {
      background: #0066CC;
    }
  }

  /* Progress Section Styles */
  .progress-section {
    padding: 20px;
    text-align: center;
  }

  .progress-info {
    margin-bottom: 20px;
  }

  .progress-text {
    color: ${(props) => props.theme.colors.primary};
    font-size: 14px;
    margin-bottom: 8px;
  }

  .progress-stats {
    color: ${(props) => props.theme.colors.primary};
    font-size: 12px;
    opacity: 0.7;
  }

  .progress-bar-container {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 16px;
  }

  .progress-bar {
    flex: 1;
    height: 8px;
    background: #303036;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #FFFFFF33;
  }

  .progress-fill {
    height: 100%;
    background: linear-gradient(90deg, #007AFF 0%, #00C7FF 100%);
    transition: width 0.3s ease;
    border-radius: 3px;
  }

  .progress-percentage {
    color: ${(props) => props.theme.colors.primary};
    font-size: 12px;
    font-weight: 500;
    min-width: 40px;
  }

  .parsing-spinner {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }

  /* Data Review Section Styles */
  .data-review-section {
    padding: 20px 0;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .data-summary {
    padding: 20px;
    background: #242A34;
    border: 1px solid #FFFFFF33;
    border-radius: 12px;
  }

  .summary-stats {
    display: flex;
    justify-content: center;
    gap: 32px;
    margin-bottom: 0;
  }

  .stat-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    min-width: 80px;
  }

  .stat-number {
    font-size: 28px;
    font-weight: 700;
    color: #007AFF;
    line-height: 1;
  }

  .stat-item:nth-child(2) .stat-number {
    color: #34C759; /* Green for playlists with descriptions */
  }

  .stat-item:nth-child(3) .stat-number {
    color: #FF9500; /* Orange for playlists without descriptions */
  }

  .stat-label {
    color: ${(props) => props.theme.colors.primary};
    font-size: 12px;
    opacity: 0.8;
    text-align: center;
    font-weight: 500;
  }

  .playlist-preview {
    padding: 20px;
    background: #242A34;
    border: 1px solid #FFFFFF33;
    border-radius: 12px;
  }

  .playlist-preview h4 {
    color: ${(props) => props.theme.colors.primary};
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 16px 0;
    text-align: center;
  }

  .playlist-list {
    max-height: 300px;
    overflow-y: auto;
    padding-right: 8px;
  }

  .playlist-list::-webkit-scrollbar {
    width: 6px;
  }

  .playlist-list::-webkit-scrollbar-track {
    background: #303036;
    border-radius: 3px;
  }

  .playlist-list::-webkit-scrollbar-thumb {
    background: #FFFFFF33;
    border-radius: 3px;
  }

  .playlist-list::-webkit-scrollbar-thumb:hover {
    background: #FFFFFF66;
  }

  .playlist-item {
    padding: 12px 16px;
    background: rgba(0, 122, 255, 0.05);
    border: 1px solid rgba(0, 122, 255, 0.2);
    border-radius: 8px;
    margin-bottom: 8px;
    transition: all 0.2s ease;

    &:hover {
      background: rgba(0, 122, 255, 0.08);
      border-color: rgba(0, 122, 255, 0.3);
    }
  }

  .playlist-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .playlist-name {
    color: ${(props) => props.theme.colors.primary};
    font-size: 13px;
    font-weight: 600;
    line-height: 1.3;
  }

  .playlist-description {
    color: ${(props) => props.theme.colors.primary};
    font-size: 11px;
    opacity: 0.7;
    line-height: 1.3;
    font-style: italic;
  }

  .more-playlists {
    text-align: center;
    padding: 12px;
    color: ${(props) => props.theme.colors.primary};
    font-size: 12px;
    opacity: 0.6;
    font-style: italic;
  }

  .import-info {
    padding: 16px 20px;
    background: rgba(0, 122, 255, 0.1);
    border: 1px solid rgba(0, 122, 255, 0.3);
    border-radius: 12px;
    display: flex;
    align-items: flex-start;
    gap: 12px;
  }

  .info-icon {
    font-size: 20px;
    line-height: 1;
    flex-shrink: 0;
    margin-top: 2px;
  }

  .info-text {
    color: ${(props) => props.theme.colors.primary};
    font-size: 12px;
    line-height: 1.4;
    opacity: 0.9;

    strong {
      color: #007AFF;
      font-weight: 600;
    }
  }

  /* Results Section Styles */
  .results-section {
    padding: 20px;
  }

  .results-summary {
    text-align: center;
  }

  .results-header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin-bottom: 20px;
  }

  .success-icon {
    font-size: 24px;
  }

  .results-header h3 {
    color: ${(props) => props.theme.colors.primary};
    font-size: 16px;
    font-weight: 500;
    margin: 0;
  }

  .results-stats {
    display: flex;
    justify-content: center;
    gap: 24px;
    margin-bottom: 20px;
  }

  .stat-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  .stat-number {
    font-size: 24px;
    font-weight: 600;
  }

  .stat-item.success .stat-number {
    color: #34C759;
  }

  .stat-item.failed .stat-number {
    color: #EA4335;
  }

  .stat-label {
    color: ${(props) => props.theme.colors.primary};
    font-size: 12px;
    opacity: 0.7;
  }

  .failed-playlists {
    margin-top: 20px;
    padding: 16px;
    background: #303036;
    border: 1px solid #EA433533;
    border-radius: 8px;
    text-align: left;
  }

  .failed-playlists h4 {
    color: #EA4335;
    font-size: 12px;
    font-weight: 500;
    margin: 0 0 12px 0;
  }

  .failed-list {
    max-height: 120px;
    overflow-y: auto;
  }

  .failed-item {
    margin-bottom: 8px;
    font-size: 11px;
    line-height: 1.4;
  }

  .playlist-name {
    color: ${(props) => props.theme.colors.primary};
    font-weight: 500;
  }

  .error-reason {
    color: ${(props) => props.theme.colors.primary};
    opacity: 0.7;
  }

  @media only screen and (max-width: 600px) {
    .ant-modal-content {
      width: 100%;
      margin: 16px;
    }

    .summary-stats {
      gap: 20px;
    }

    .stat-item {
      min-width: 60px;
    }

    .stat-number {
      font-size: 24px;
    }

    .stat-label {
      font-size: 11px;
    }

    .playlist-preview {
      padding: 16px;
    }

    .playlist-item {
      padding: 10px 12px;
    }

    .playlist-name {
      font-size: 12px;
    }

    .playlist-description {
      font-size: 10px;
    }

    .import-info {
      padding: 12px 16px;
      gap: 10px;
    }

    .info-icon {
      font-size: 18px;
    }

    .info-text {
      font-size: 11px;
    }
  }
`;
